(() => {
  let buyButtons = null;
  let buyButtonsCheck = null;

  const elementIsVisibleInViewport = (element, partiallyVisible = false) => {
    const { top, left, bottom, right } = element.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;

    return partiallyVisible
      ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  };

  function unfade(element) {
    let opacity = 0.1;
    const timer = setInterval(function () {
      if (opacity >= 1) {
        clearInterval(timer);
        element.classList.remove('transition');
      }
      element.style.opacity = opacity;
      element.style.filter = `alpha(opacity=${opacity * 100})`;
      opacity += opacity * 0.1;
    }, 15);
  }

  function buyButtonsPosition() {
    if (!elementIsVisibleInViewport(buyButtonsCheck, true)) {
      if (!buyButtons.classList.contains('transition') && !buyButtons.classList.contains('sticky')) {
        buyButtons.classList.add('sticky');
        buyButtons.style.opacity = 0;
        buyButtons.classList.add('transition');
        unfade(buyButtons);
      }
    } else if (!buyButtons.classList.contains('transition') && buyButtons.classList.contains('sticky')) {
      buyButtons.classList.remove('sticky');
      buyButtons.style.opacity = 0;
      buyButtons.classList.add('transition');
      unfade(buyButtons);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    buyButtons = document.querySelector('.product-details .group-block.color-scheme-2');
    buyButtonsCheck = document.getElementById('buyButtonVisibilityCheck');

    if (buyButtons && buyButtonsCheck) {
      window.addEventListener('scroll', () => {
        buyButtonsPosition();
      });

      buyButtonsPosition();
    }
  });

  const triggers = [
    '#emailCtaLink',
    '#ringSizeGuide',
    '#bangleSizeGuide',
    '.text-block--AQkUrOXZTU1Vkd2Ire__text_LJDpPh a',
    '#poaLink',
    '#necklaceSizeGuide',
  ];
  const popups = [
    '[id$="__popup_link_Pymp4z"]',
    '[id$="__popup_link_Fyki98"]',
    '[id$="__popup_link_awUjqV"]',
    '[id$="__popup_link_Pymp4z"]',
    '[id$="__popup_link_Pymp4z"]',
    '[id$="__popup_link_XFeTpk"]',
  ];

  for (let index = 0; index < triggers.length; index++) {
    const trigger = document.querySelector(triggers[index]);
    const popup = document.querySelector(popups[index]);

    if (trigger && popup) {
      trigger.addEventListener('click', function () {
        popup.click();
      });
    }
  }
})();
